import { chatUserTrackerQuery } from "$relay/chatUserTrackerQuery.graphql"
import { Environment } from "react-relay"
import { fetchQuery, graphql } from "relay-runtime"

import { CurrentUser } from "../../CoreContext"

// Nakama sends us presence events for all users in the match, but
// the information they give us is sparse. We don't get a userID which we can use from
// relay to access the in-memory store, so we need to track users via this fn

// nakamaUsername = either orta#pz or xyz213 (the puzmo gameplay ID via the userstate's ownerID)

// note: the allowed fields from the API are set, so any new fields needs API changes
export const getUserInfoFromNakamaID = graphql`
  query chatUserTrackerQuery($nakamaID: String!) {
    userFromNakamaID(nakamaID: $nakamaID) {
      id
      username
      usernameID
      avatarURL
      nakamaID
    }
  }
`

export type NakamaChatMesssageUser = NonNullable<chatUserTrackerQuery["response"]["userFromNakamaID"]>

export const createChatUserTracker = (
  environment: Environment,
  currentUser: CurrentUser,
  notify: (channelID: string, nID: string, user: NakamaChatMesssageUser) => void
) => {
  // Keeps track of the requests for users who connect to the game
  const userData = new Map<string, NakamaChatMesssageUser>()
  if (currentUser.currentUser) {
    userData.set(currentUser.currentUser.nakamaID, currentUser.currentUser)
  }

  const loading = new Set<string>()

  return {
    getUserInfo: (channelID: string, nID: string) => {
      const u = userData.get(nID)
      if (u) return u

      if (loading.has(nID)) return undefined
      loading.add(nID)

      // Grab the rich metadata, e..g profile image etc
      fetchQuery<chatUserTrackerQuery>(environment, getUserInfoFromNakamaID, {
        nakamaID: nID,
      })
        .toPromise()
        .then((data) => {
          const realUser = data?.userFromNakamaID
          if (realUser) {
            userData.set(nID, realUser)
            loading.delete(nID)
            notify(channelID, nID, realUser)
          }
        })

      return undefined
    },
    loads: () => loading.size,
  }
}
